import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

type SidePanelFooterProps = {
	children: React.ReactNode;
};

const footerBaseStyles = xcss({
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	borderTopWidth: 'border.width',
});

export const SidePanelFooter = ({ children }: SidePanelFooterProps) => {
	return (
		<Box paddingBlock="space.200" paddingInline="space.300" xcss={footerBaseStyles}>
			{children}
		</Box>
	);
};
